import React from 'react';
import { css } from 'styled-components';
import CustomMedia from 'util/custom-media-query';
import { applyStyles } from 'util/helpers';
import Image from 'components/common/Image';
import Colors from 'constants/colors';
import FontStyles from 'constants/font-styles';
import icBtnPlus1x from 'assets/images/common/@1x/ic_btn_plus.png';
import icBtnPlus2x from 'assets/images/common/@2x/ic_btn_plus@2x.png';
import icBtnPlus3x from 'assets/images/common/@3x/ic_btn_plus@3x.png';
import icBtnMinus1x from 'assets/images/common/@1x/ic_btn_minus.png';
import icBtnMinus2x from 'assets/images/common/@2x/ic_btn_minus@2x.png';
import icBtnMinus3x from 'assets/images/common/@3x/ic_btn_minus@3x.png';
import AboutContent from './AboutContent';

class AboutHeader extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      opened: false
    };

    this.handleClickToggle = this.handleClickToggle.bind(this);
  }

  handleClickToggle = () => {
    this.setState({
      opened: !this.state.opened
    });
  };

  render() {
    const { className, name, content, detail } = this.props;

    return (
      <div className={className}>
        <div className="card">
          {name ? (
            <div>
              <div className="header" onClick={this.handleClickToggle}>
                <button>
                  {this.state.opened ? (
                    <Image
                      common1x={icBtnMinus1x}
                      common2x={icBtnMinus2x}
                      common3x={icBtnMinus3x}
                      alt="ic_btn_minus"
                    />
                  ) : (
                    <Image
                      common1x={icBtnPlus1x}
                      common2x={icBtnPlus2x}
                      common3x={icBtnPlus3x}
                      alt="ic_btn_plus"
                    />
                  )}
                </button>
                <p className="name">{name}</p>
              </div>
              <div>
                <div className={`open-box ${this.state.opened ? '' : 'close'}`}>
                  <AboutContent content={content} detail={detail} />
                </div>
              </div>
            </div>
          ) : (
            <AboutContent content={content} detail={detail} />
          )}
        </div>
      </div>
    );
  }
}

const commonStyle = css`
  p {
    margin: 0;
  }

  .card {
    border: 1px solid ${Colors.gray2};
    margin-bottom: 24px;

    .header {
      position: relative;
      cursor: pointer;

      button {
        padding: 0;
        position: absolute;
        top: 50%;
        float: left;
        border: 0;
        outline: 0;
        background: transparent;
      }
    }

    .name {
      color: ${Colors.black1};
    }

    .open-box {
      overflow: hidden;
      max-height: 232px;
      transition: max-height 0.4s ease;

      &.close {
        max-height: 0;
      }
    }

    > ${AboutContent} {
      border-top: none;
    }
  }
`;

const pcStyle = CustomMedia.greaterThan('umedium')`
  .card {
    &:hover {
      background-color: ${Colors.gray4};
    }

    .name {
      margin-left: 36px;
      ${FontStyles.text7};
    }

    .header {
      padding: 19px 24px;

      button {
        margin-top: -15px;
      }
    }
  }
`;

const spStyle = CustomMedia.lessThan('medium')`
  .card {
    .name {
      margin-left: 28px;
      ${FontStyles.text5};
    }

    .header {
      padding: 15px 16px;

      button {
        margin-top: -13px;
      }
    }
  }
`;

export default applyStyles(AboutHeader)(commonStyle, pcStyle, spStyle);



// WEBPACK FOOTER //
// ./src/components/Faq/components/AboutHeader.js